<template>
  <footer class="footer" id="footer">
    <div class="section nav-section">
      <div class="wrapper">
        <div class="left">
          <div class="desc">
            {{ $parent.settings.requisites }}
          </div>
        </div>
        <div class="center">
          <ul class="nav">
            <li
              class="nav__item"
              v-for="(item, i) in $parent.textPageList"
              :key="i"
            >
              <a @click="$emit('goToPage', item)" class="desc">
                {{ item.title }}
              </a>
            </li>
          </ul>
          <router-link to="/" class="logo">
            <img src="../img/logo.svg" class="img" />
            <div class="title title-28">
              rust<span class="gray">legacys</span>
            </div>
          </router-link>
        </div>

        <div class="right" v-if="$parent.settings.support_email">
          <div class="desc">
            <span class="yellow">{{ $parent.settings.support_email }}</span>
          </div>
          <div class="footer-social">
            <a
              target="_blank"
              :href="link.link"
              v-for="link in $parent.socials"
              :key="link.image"
              class="footer-social-link"
            >
              <img :src="link.image" :alt="link.link" />
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="section methods-section">
      <div class="wrapper">
        <div class="left">
          <div class="desc">
            {{ $parent.settings.copyright }}
          </div>
        </div>
        <div class="right">
          <img src="../img/methods/1.svg" class="img" />
          <img src="../img/methods/2.svg" class="img" />
          <img src="../img/methods/3.svg" class="img" />
          <img
            src="../img/methods/4.svg"
            class="img"
            v-if="
              $parent.settings.payment_methods.find(
                (item) => item.code == 'applepay'
              )
            "
          />
          <img
            src="../img/methods/5.svg"
            class="img"
            v-if="
              $parent.settings.payment_methods.find(
                (item) => item.code == 'googlepay'
              )
            "
          />
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: [],
  data: function () {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>

<style lang="scss" scoped>
.footer-social {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
  margin-top: 46px;

  &-link {
    img {
      height: 40px;
      display: block;
    }
  }
}
.methods-section {
  .img {
    height: 30px;
  }
}
</style>
